import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { PdfIzdatnicaSirovinaIzradiService } from 'src/app/pdf-ovi/pdfIzdatnicaSirovinaIzradi.service';
import { PdfIzdatnicaSirovinaZavrseniService } from 'src/app/pdf-ovi/pdfIzdatnicaSirovinaZavrseni.service';
import { PdfZaIzdatnicePotrosnogMaterijalaService } from 'src/app/pdf-ovi/pdfZaIzdatnicePotrosnogMaterijala.service';
import { PdfZaDostavniceService } from 'src/app/pdf-ovi/pdfZaDostavnice.service';
import { PdfZaOtpremniceService } from 'src/app/pdf-ovi/pdfZaOtpremnice.service';
import { moduli } from '../../config';
import { DokumentiService } from './dokumenti.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-dokumenti',
  templateUrl: './dokumenti.component.html',
  styleUrls: ['./dokumenti.component.scss'],
})
export class DokumentiComponent implements OnInit {
  dokumenti: any = [];
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');
  idDokumenta: number;
  poSifra = '';

  dokumentiDatum: any = [];
  poslovnice = [
    {
      firma_fi_id: 2,
      idposlovnica: 1,
      po_broj_redova_desno: 0,
      po_broj_redova_lijevo: 0,
      po_kapacitet: 0,
      po_kapacitet_desno: 0,
      po_kapacitet_lijevo: 0,
      po_naziv: 'SVE',
      po_sifra: 'all',
      sifrainaziv: 'SVE',
      vrstaposlovnice_idvrstaposlovnice: null,
    },
  ];

  poruka: string;
  disableGumb: boolean = false;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(
    private router: Router,
    private service: DokumentiService,
    private dostavniceService: PdfZaDostavniceService,
    private otpremniceService: PdfZaOtpremniceService,
    private izdatniceZavrseniService: PdfIzdatnicaSirovinaZavrseniService,
    private izdatniceIzradiService: PdfIzdatnicaSirovinaIzradiService,
    private izdatnicePotrosnogMaterijalaService: PdfZaIzdatnicePotrosnogMaterijalaService,
  ) {
    //this.dohvatiDokumente(this.datumOdFormatiran, this.datumDoFormatiran);
    this.dohvatiPoslovnice();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().dokumenti;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  backButtonClicked() {
    this.router.navigate(['/nadzorna-ploca']);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      {
        location: 'before',
        template: 'naslovTablice',
      }
      // {
      //   location: 'before',
      //   template: 'odabirPoslovnice',
      // }
    );
  }

  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "pz_status"){
        if (options.value == 'I') {
          options.cellElement.classList.add('circleYellow');
        }
        if (options.value == 'U') {
          options.cellElement.classList.add('circleBlue');
        }
        if (options.value == 'S') {
          options.cellElement.classList.add('circleRed');
        }
        if (options.value == 'Z') {
          options.cellElement.classList.add('circleGreen');
        }
      }
    }
  }

  calculateSortValue(rowData: any) {
    // If your receipt numbers are in format like "PZ-2024-001"
    const receiptNumber = rowData.pz_broj;
    
    // Remove any non-numeric characters and convert to number
    // This will sort based on the numeric value
    return parseInt(receiptNumber.replace(/\D/g, ''));
    
    // OR if you want to sort by the full string but in a specific way:
    // return receiptNumber.padStart(10, '0');
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
  }

  pretrazi(){
    this.dohvatiDokumente(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  dohvatiDokumente(datumod, datumdo): void {
    this.poruka = 'Učitavanje...';
    this.disableGumb = true;
    this.dokumenti = [];
    const data = {
      datumod: datumod,
      datumdo: datumdo,
      posifra: this.poSifra,
    };
    this.service.dohvatiDokumentePoPoslovnici(data).subscribe((res) => {
      //console.log(res);
      this.disableGumb = false;
      if (res.success === true) {
        this.dokumenti = res.data;
      }
      if (res.data.length > 0) {
        this.poruka = 'Učitavanje...';
      }else{
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  dohvatiPoslovnice() {
    this.service.dohvatiSvePoslovnice({}).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.poslovnice.push(...res.data);
      }
    });
  }

  promjenaPoslovnice(e) {
    //console.log(e);
    this.poSifra = e.value;
  }

  pdfDostavnica(data) {
    this.dostavniceService.pdfDostavnica(data);
  }

  pdfOtpremnica(data) {
    this.otpremniceService.pdfOtpremnica(data);
  }

  pdfIzdatnicaSirovinaZavrseno(data) {
    this.izdatniceZavrseniService.pdfIzdatnicaSirovinaZavrseno(data);
  }

  pdfIzdatnicaSirovinaIzradi(data) {
    this.izdatniceIzradiService.pdfIzdatnicaSirovinaIzradi(data);
    this.dohvatiDokumente(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  pdfIzdatnicaPotrosnogMaterijala(data) {
    this.izdatnicePotrosnogMaterijalaService.izdatnicaPotrosnogMaterijalaPDF(data);
  }

  ngOnInit() {}
}
